/* eslint-disable no-param-reassign */
import { createAction } from '@reduxjs/toolkit';

import applyTreeSelectionCommitToState from './helpers/applyTreeSelectionCommitToState';
import createTreeSelectionThunk from './helpers/createTreeSelectionThunk';
import { getProductGroupTogglePlan } from './helpers/treeSelection';
import { MASTER_SELECTION_CONTEXT } from './helpers/selectionContext';

export const selectTreeProductGroupCommit = createAction('products/selectTreeProductGroup/commit');

export const selectTreeProductGroup = createTreeSelectionThunk(
  'products/selectTreeProductGroup',
  selectTreeProductGroupCommit,
);

export const reducer = (builder) => {
  builder.addCase(selectTreeProductGroupCommit, (state, { payload }) => {
    const {
      productId, variantIds = [], productNode, keepChannelSelection,
    } = payload;
    const plan = getProductGroupTogglePlan(productId, variantIds, productNode, state.ui.selection);
    applyTreeSelectionCommitToState(state, {
      ...plan,
      context: MASTER_SELECTION_CONTEXT,
      lastClickedKey: `master:${productId}`,
      keepChannelSelection,
      source: 'tree',
    });
  });
};
